import { useEffect, useState } from "react";
import styled from "styled-components";
import { SuccessButton } from "../styles/button";
import { CatModel } from "../models/cat";
import { CatComponent } from "../components/cat_component";
import { addCatToGlobalStore } from "../stores/cat_store";
import { Translate } from "../components/translate";

export function Cat() {
  const [cat, setCat] = useState<CatModel>();

  function fetchCat() {
    setCat(undefined);
    fetch("https://api.thecatapi.com/v1/images/search")
      .then((response) => response.json())
      .then((data) => {
        setCat(data[0]);
        addCatToGlobalStore(data[0]);
      });
  }
  useEffect(() => {
    fetchCat();
  }, []);

  return (
    <Container>
      <SuccessButton onClick={() => fetchCat()}>
        <Translate value="new_cat" />
      </SuccessButton>
      {cat === undefined ? <div>Loading...</div> : <CatComponent cat={cat} />}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 20px;
`;
